import React, { Component } from "react";
import "./App.css";

import BenutzerdatenBlock from "./BenutzerdatenBlock";
import TeilnahmebedingungenBlock from "./TeilnahmebedingungenBlock";
import DeinRezeptBlock from "./DeinRezeptBlock";
import FotoBlock from "./FotoBlock";
import ZutatenBlock from "./ZutatenBlock";
import ZubereitungBlock from "./ZubereitungBlock";
import CommunityTippBlock from "./CommunityTippBlock";
import DankeBlock from "./DankeBlock";
import KopfLayoutBlock from "./KopfLayoutBlock";
import ErrorBlock from "./ErrorBlock";

const FORM_INVALID_STATE = 1;
const FORM_UNTOUCHED_STATE = 2;
const FORM_VALID_STATE = 3;
const FORM_TOUCHED_STATE = 4;
const FORM_SENT = 5;

//let errorName = "";

class App extends Component {
  constructor(props) {
    super(props);
    document.title = "Odernichtoderdoch.de Heldenk&uuml;che";

    this.props.formData.formIsValid = FORM_UNTOUCHED_STATE;
    this.props.formData.errorMessageText = "";
    this.props.formData.errName = "";
    this.props.formData.SubmitButtonCalled = true;
    this.state = this.props.formData;

    //  this.setState({thankYouMessage:'Vielen Dank!'});

    // Übergibt an die Methode handleSubmit den Context $this (quasi als Globale-Variable)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRezeptnameChange = this.handleRezeptnameChange.bind(this);
    this.handleAnzahlPortionenChange =
      this.handleAnzahlPortionenChange.bind(this);
    this.handleFarbeChange = this.handleFarbeChange.bind(this);
    this.handleKochzeitChange = this.handleKochzeitChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleVornameChange = this.handleVornameChange.bind(this);
    this.handleNachnameChange = this.handleNachnameChange.bind(this);
    this.handleEMailChange = this.handleEMailChange.bind(this);
    this.handleInstagramnameChange = this.handleInstagramnameChange.bind(this);
    this.handleCommunityTippChange = this.handleCommunityTippChange.bind(this);
    this.handlePictureMealChange = this.handlePictureMealChange.bind(this);
    this.handlePictureSelfieChange = this.handlePictureSelfieChange.bind(this);
    this.handleIngredientsChange = this.handleIngredientsChange.bind(this);
    this.handlePreparationsChange = this.handlePreparationsChange.bind(this);
    this.handleTeilnahmeBedingungenAkzeptiertChange =
      this.handleTeilnahmeBedingungenAkzeptiertChange.bind(this);
    this.handleErrorMessageText = this.handleErrorMessageText.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // State-Changes für Rezept-Block
  handleRezeptnameChange(x) {
    this.setState({ rezeptname: x });

    if (x.length === 0) {
      this.setState({ formIsValid: FORM_INVALID_STATE });
      // Formular ist nicht valide => Vorname ist Pflichtfeld
      if (this.state.SubmitButtonCalled) {
        this.setState({ rezeptnameIsValid: FORM_INVALID_STATE });
      }
    }
    if (x.length > 0) {
      if (this.state.formIsValid === FORM_UNTOUCHED_STATE) {
        this.setState({ formIsValid: FORM_TOUCHED_STATE });
      }
      this.setState({ rezeptnameIsValid: FORM_VALID_STATE });
    }
  }
  handleErrorMessageText(errormessage) {
    this.setState({ errorMessageText: errormessage });
  }
  handleAnzahlPortionenChange(anzahlPortionen) {
    this.setState({ anzahlPortionen: anzahlPortionen });
  }
  handleFarbeChange(farbe) {
    this.setState({ farbe: farbe });
  }
  handleKochzeitChange(x) {
    this.setState({ kochzeit: x });
  }

  handleTeilnahmeBedingungenAkzeptiertChange(x) {
    this.setState({ teilnahmeBedingungenAkzeptiert: x });
    if (x === 0) {
      this.setState({ formIsValid: FORM_INVALID_STATE });
      // Formular ist nicht valide => Vorname ist Pflichtfeld
      if (this.state.SubmitButtonCalled) {
        this.setState({
          teilnahmeBedingungenAkzeptiertIsValid: FORM_INVALID_STATE,
        });
      }
    }
    if (x === 1) {
      if (this.state.formIsValid === FORM_UNTOUCHED_STATE) {
        this.setState({ formIsValid: FORM_TOUCHED_STATE });
      }
      this.setState({
        teilnahmeBedingungenAkzeptiertIsValid: FORM_VALID_STATE,
      });
    }
  }

  // State-Changes für Benutzerdaten-Block
  handleVornameChange(x) {
    this.setState({ vorname: x });
    // Validierung für den Vornamen auf oberster Ebene!
    if (x.length === 0) {
      this.setState({ formIsValid: FORM_INVALID_STATE });
      // Formular ist nicht valide => Vorname ist Pflichtfeld
      if (this.state.SubmitButtonCalled) {
        this.setState({ vornameIsValid: FORM_INVALID_STATE });
      }
    }
    if (x.length > 0) {
      if (this.state.formIsValid === FORM_UNTOUCHED_STATE) {
        this.setState({ formIsValid: FORM_TOUCHED_STATE });
      }
      this.setState({ vornameIsValid: FORM_VALID_STATE });
    }
  }
  handleNachnameChange(x) {
    this.setState({ nachname: x });
    if (x.length === 0) {
      this.setState({ formIsValid: FORM_INVALID_STATE });
      // Formular ist nicht valide => Vorname ist Pflichtfeld
      if (this.state.SubmitButtonCalled) {
        this.setState({ nachnameIsValid: FORM_INVALID_STATE });
      }
    }
    if (x.length > 0) {
      if (this.state.formIsValid === FORM_UNTOUCHED_STATE) {
        this.setState({ formIsValid: FORM_TOUCHED_STATE });
      }
      this.setState({ nachnameIsValid: FORM_VALID_STATE });
    }
  }
  handleEMailChange(x) {
    this.setState({ email: x });
    if (x.length === 0) {
      this.setState({ formIsValid: FORM_INVALID_STATE });
      // Formular ist nicht valide => Vorname ist Pflichtfeld
      if (this.state.SubmitButtonCalled) {
        this.setState({ emailIsValid: FORM_INVALID_STATE });
      }
    }
    if (x.length > 0) {
      if (this.state.formIsValid === FORM_UNTOUCHED_STATE) {
        this.setState({ formIsValid: FORM_TOUCHED_STATE });
      }
      this.setState({ emailIsValid: FORM_VALID_STATE });
    }
  }
  handleInstagramnameChange(x) {
    this.setState({ instagramname: x });
  }

  // State-Changes für FotoBlock
  handlePictureMealChange(x) {
    this.setState({ picture_meal: x });
  }
  handlePictureSelfieChange(x) {
    this.setState({ picture_selfie: x });
  }

  // State-Changes für Zutaten(-Block)
  handleIngredientsChange(x) {
    this.setState({ ingredients: x });
  }
  // State-Changes für Rezpet-Kategorie 31337

  handleCategoryChange(x) {
    this.setState({ category_id: x });

    if (x.length === 0) {
      console.log("this.category_id.category_id.length.INVALID");
      this.setState({ formIsValid: FORM_INVALID_STATE });
      this.setState({ category_idIsValid: FORM_INVALID_STATE });
    } else {
      this.setState({ category_idIsValid: FORM_VALID_STATE });
    }
  }
  // State-Changes für Zubereitung (-Block)
  handlePreparationsChange(x) {
    this.setState({ preparations: x });
  }

  // State-Changes für Community Tipp (-Block)
  handleCommunityTippChange(x) {
    this.setState({ communityTipp: x });
  }
  // Submit Event des Formulares...
  handleSubmit(event) {
    console.clear();
    event.preventDefault();
    //const _this = this;

    //this.setState({formIsValid: FORM_VALID_STATE});

    let formIsValid = this.state.FORM_VALID_STATE;
    let errorsString = [];
   

    if (this.state.vorname.length === 0) {
      formIsValid = FORM_INVALID_STATE;
      this.setState({ vornameIsValid: FORM_INVALID_STATE });
      errorsString.push("Du hast keinen Vornamen hinzugefügt");
      this.setState({ errName: errorsString});
    } else {
      this.setState({ vornameIsValid: FORM_VALID_STATE });
    }

    if (this.state.nachname.length === 0) {
      formIsValid = FORM_INVALID_STATE;
      this.setState({ nachnameIsValid: FORM_INVALID_STATE });
      errorsString.push("Du hast keinen Nachnamen hinzugefügt");
      this.setState({ errName: errorsString});
    } else {
      this.setState({ nachnameIsValid: FORM_VALID_STATE });
    }

    if (this.state.email.length === 0) {
      formIsValid = FORM_INVALID_STATE;
      this.setState({ emailIsValid: FORM_INVALID_STATE });
      errorsString.push("Du hast keine Email hinzugefügt");
      this.setState({ errName: errorsString});
    } else {
      this.setState({ emailIsValid: FORM_VALID_STATE });
    }

    if (this.state.rezeptname.length === 0) {
      formIsValid = FORM_INVALID_STATE;
      this.setState({ rezeptnameIsValid: FORM_INVALID_STATE });
      errorsString.push("Du hast keinen Rezeptnamen hinzugefügt");
      this.setState({ errName: errorsString});
    } else {
      this.setState({ rezeptnameIsValid: FORM_VALID_STATE });
    }

    if (this.state.category_id.length === 0) {
      formIsValid = FORM_INVALID_STATE;
      this.setState({ category_idIsValid: FORM_INVALID_STATE });
      errorsString.push("Du hast keine Kategorie ausgewählt");
      this.setState({ errName: errorsString});
    } else {
      this.setState({ category_idIsValid: FORM_VALID_STATE });
      if (this.state.category_id < 1 && this.state.category_id < 6) {
        formIsValid = FORM_INVALID_STATE;
        this.setState({ category_idIsValid: FORM_INVALID_STATE });
      errorsString.push("Du hast keine richtige Kategorie ausgewählt");
        this.setState({ errName: errorsString});
      } else {
        this.setState({ category_idIsValid: FORM_VALID_STATE });
      }
    }

    if (this.state.picture_meal.length === 0) {
      formIsValid = FORM_INVALID_STATE;
      this.setState({ picture_mealIsValid: FORM_INVALID_STATE });
      errorsString.push("Du hast kein Bild des Essens hinzugefügt");
      this.setState({ errName: errorsString});
    } else {
      this.setState({ picture_mealIsValid: FORM_VALID_STATE });
    }

    if (this.state.picture_selfie.length === 0) {
      formIsValid = FORM_INVALID_STATE;
      this.setState({ picture_selfieIsValid: FORM_INVALID_STATE });
      errorsString.push("Du hast kein Selfie-Bild hinzugefügt");
      this.setState({ errName: errorsString});
    } else {
      this.setState({ picture_selfieIsValid: FORM_VALID_STATE });
    }

    if (this.state.teilnahmeBedingungenAkzeptiert === 0) {
      formIsValid = FORM_INVALID_STATE;
      this.setState({
        teilnahmeBedingungenAkzeptiertIsValid: FORM_INVALID_STATE,
      });
      errorsString.push("Du hast die Bedingungen nicht akzeptiert");
      this.setState({ errName: errorsString });
    } else {
      this.setState({
        teilnahmeBedingungenAkzeptiertIsValid: FORM_VALID_STATE,
      });
    }

    // Prüfen ob Zutaten angeben wurden...
    let buffer_ingredients = this.state.ingredients;
    buffer_ingredients = buffer_ingredients.filter(function (n) {
      return n !== undefined;
    });

    console.log(buffer_ingredients);
    if (buffer_ingredients.length === 0) {
      formIsValid = FORM_INVALID_STATE;
      this.setState({ ingredientsIsValid: FORM_INVALID_STATE });
      errorsString.push("Zutaten: Du musst zumindest ein Feld ausfüllen.");
      this.setState({ errName: errorsString});
    } else {
      const zutatenProof = buffer_ingredients.shift();
      if (
        zutatenProof.menge === "" &&
        zutatenProof.einheit === "" &&
        zutatenProof.zutat === ""
      ) {
        formIsValid = FORM_INVALID_STATE;
        this.setState({ ingredientsIsValid: FORM_INVALID_STATE });
      errorsString.push("Zutaten: Du musst zumindest ein Feld ausfüllen.");
        this.setState({ errName: errorsString});
      } else {
        this.setState({ ingredientsIsValid: FORM_VALID_STATE });
      }
    }

    let buffer_preps = this.state.preparations;
    buffer_preps = buffer_preps.filter(function (n) {
      return n !== undefined;
    });

    console.log(buffer_preps);
    if (buffer_preps.length === 0) {
      formIsValid = FORM_INVALID_STATE;
      this.setState({ preparationsIsValid: FORM_INVALID_STATE });
      console.log("no preparationsIsValid ");
      errorsString.push("Zubereitungen: Du musst zumindest ein Feld ausfüllen.");
      this.setState({ errName: errorsString});
    } else {
      const zubereitungProof = buffer_preps.shift();
      console.log(zubereitungProof);
      if (zubereitungProof.zubereitung === "") {
        formIsValid = FORM_INVALID_STATE;
        this.setState({ preparationsIsValid: FORM_INVALID_STATE });
        console.log("preparationsIsValid invalid!");
      errorsString.push("Zubereitungen: Du musst zumindest ein Feld ausfüllen.");
        this.setState({ errName: errorsString});
      } else {
        this.setState({ preparationsIsValid: FORM_VALID_STATE });
      }
    }

    this.forceUpdate();
    let _this2 = this;

    if (formIsValid !== FORM_INVALID_STATE) {
      var request = new XMLHttpRequest();
      request.onreadystatechange = (e) => {
        if (request.readyState !== 4) {
          return;
        }

        if (request.status === 200) {
          _this2.setState({ formIsValid: FORM_SENT });
          _this2.forceUpdate();
          console.log(_this2.state.formIsValid);
        } else {
          console.warn("error");
        }
      };

      request.open("POST", "https://odernichtoderdoch.de/addons/rezepte/add");
      request.setRequestHeader("Content-Type", "application/json");
      request.send(JSON.stringify(this.state));
    } else {
      //var eerr = "Bitte überprüfe deine Eingaben!"+"\n"+errorName;
      this.setState({
        formIsValid: FORM_INVALID_STATE,
        errorMessageText: "Bitte überprüfe deine Eingaben!",
      });
    }
  }

  render() {
    // Wenn Formular abgesendet, geben wir dem Formular eine andere Klasse!
    let formClass =
      "Form-" + (this.state.formIsValid === FORM_SENT ? "Hide" : "Shown");
    let errorMessageClass =
      "ErrorMessage-" +
      (this.state.formIsValid === FORM_INVALID_STATE ? "Shown" : "GHide");
    return (
      <div className="App">
        <KopfLayoutBlock />
        <div className={errorMessageClass}>{this.state.errorMessageText}</div>
        <form
          id="receiptForm"
          onSubmit={this.handleSubmit}
          className={formClass}
        >
          <section id="erfassung">
            <BenutzerdatenBlock
              vorname={this.state.vorname}
              vornameIsValid={this.state.vornameIsValid}
              onVornameChange={this.handleVornameChange}
              nachname={this.state.nachname}
              nachnameIsValid={this.state.nachnameIsValid}
              onNachnameChange={this.handleNachnameChange}
              email={this.state.email}
              emailIsValid={this.state.emailIsValid}
              onEMailChange={this.handleEMailChange}
              instagramname={this.state.instagramname}
              onInstagramnameChange={this.handleInstagramnameChange}
            />
            <TeilnahmebedingungenBlock
              teilnahmeBedingungenAkzeptiert={
                this.state.teilnahmeBedingungenAkzeptiert
              }
              teilnahmeBedingungenAkzeptiertIsValid={
                this.state.teilnahmeBedingungenAkzeptiertIsValid
              }
              onTeilnahmeBedingungenAkzeptiertChange={
                this.handleTeilnahmeBedingungenAkzeptiertChange
              }
            />

            <DeinRezeptBlock
              rezeptname={this.state.rezeptname}
              rezeptnameIsValid={this.state.rezeptnameIsValid}
              onRezeptnameChange={this.handleRezeptnameChange}
              anzahlPortionen={this.state.anzahlPortionen}
              onAnzahlPortionenChange={this.handleAnzahlPortionenChange}
              farbe={this.state.farbe}
              onFarbeChange={this.handleFarbeChange}
              kochzeit={this.state.kochzeit}
              onKochzeitChange={this.handleKochzeitChange}
              category_id={this.state.category_id}
              category_idIsValid={this.state.category_idIsValid}
              onCategoryChange={this.handleCategoryChange}
            />

            <FotoBlock
              picture_selfie={this.state.picture_selfie}
              picture_selfieIsValid={this.state.picture_selfieIsValid}
              picture_meal={this.state.picture_meal}
              picture_mealIsValid={this.state.picture_mealIsValid}
              onPictureMealChange={this.handlePictureMealChange}
              onPictureSelfieChange={this.handlePictureSelfieChange}
              errorMessageText={this.state.errorMessageText}
              onErrorMessageText={this.handleErrorMessageText}
            />

            <ZutatenBlock
              ingredients={this.state.ingredients}
              onIngredientsChange={this.handleIngredientsChange}
              ingredientsIsValid={this.state.ingredientsIsValid}
            />
            <ZubereitungBlock
              preparations={this.state.preparations}
              onPreparationsChange={this.handlePreparationsChange}
              preparationsIsValid={this.state.preparationsIsValid}
            />
            <CommunityTippBlock
              communityTipp={this.state.communityTipp}
              onCommunityTippChange={this.handleCommunityTippChange}
            />

            <section id="Abschuss">
              <button type="submit" className="btn stdrose center">
                Rezept abschicken
              </button>
            </section>
          </section>
        </form>
        <DankeBlock
          formIsValid={this.state.formIsValid}
          thankYouMessage={this.state.thankYouMessage}
        />
        <ErrorBlock
          formIsValid={this.state.formIsValid}
          errorMessageText={this.state.errorMessageText}
          onErrorMessageText={this.handleErrorMessageText}
          errName={this.state.errName}
        />
      </div>
    );
  }
}
/*

      
*/
export default App;



// WEBPACK FOOTER //
// ./src/App.js